module.exports = __webpack_public_path__ + "img/small.be5030ca.webp";